import constate from "constate";
import {useReducer} from "react";
import createReducer from "helpers/reducers-helper";
import repo from "service/repository";
import assign from "lodash/assign";
import {useHistory} from "react-router-dom";
import {isEmail} from "helpers/rule-validation";
import merge from "lodash/merge";
import {useAppContext, SHOW_APP_MESSAGE, UPDATE_USER_INFO} from "use-app";
import {errorHandler} from "helpers/error-handler";

export const CHANGE_EMAIL = "CHANGE_EMAIL";
export const CHANGE_EMAIL_ERROR_MESSAGE = "CHANGE_EMAIL_ERROR_MESSAGE";
export const CHANGE_DISPLAY_NAME = "CHANGE_DISPLAY_NAME";
export const CHANGE_DISPLAY_NAME_ERROR_MESSAGE = "CHANGE_DISPLAY_NAME_ERROR_MESSAGE";
export const START_SAVING = "START_SAVING";
export const HIDE_LOADING = "HIDE_LOADING";

export const useProfileSetting = () => {
  const {state: appState, dispatch: appDispatch} = useAppContext();
  const receipt = appState.me?.receipt;

  const history = useHistory();

  const initState = {
    email: appState.me?.email,
    emailErrorMessage: "",
    displayName: appState.me?.displayName,
    displayNameErrorMessage: "",
    loading: false,
  };

  const changeEmail = (state, payload) => {
    return assign({}, state, {email: payload});
  };
  const changeEmailErrorMessage = (state, payload) => {
    return assign({}, state, {emailErrorMessage: payload});
  };
  const changeDisplayName = (state, payload) => {
    return assign({}, state, {displayName: payload});
  };
  const changeDisplayNameErrorMessage = (state, payload) => {
    return assign({}, state, {displayNameErrorMessage: payload});
  };
  const startSaving = (state) => merge({}, state, {loading: true});
  const hideLoading = (state) => merge({}, state, {loading: false});

  const reducer = createReducer({
    [CHANGE_EMAIL]: changeEmail,
    [CHANGE_EMAIL_ERROR_MESSAGE]: changeEmailErrorMessage,
    [CHANGE_DISPLAY_NAME]: changeDisplayName,
    [CHANGE_DISPLAY_NAME_ERROR_MESSAGE]: changeDisplayNameErrorMessage,
    [START_SAVING]: startSaving,
    [HIDE_LOADING]: hideLoading,
  });

  const [state, dispatch] = useReducer(reducer, initState);

  const updateProfile = (email, displayName) => {
    const profileCheck = () => {
      const isEmailValid = isEmail(email);
      const emailErrorMessage = isEmailValid ? "" : "電子郵件格式錯誤";
      const isDisplayNameValid = displayName !== "";
      const displayNameErrorMessage = isDisplayNameValid ? "" : "暱稱錯誤";

      dispatch({type: CHANGE_EMAIL_ERROR_MESSAGE, payload: emailErrorMessage});
      dispatch({type: CHANGE_DISPLAY_NAME_ERROR_MESSAGE, payload: displayNameErrorMessage});

      return isEmailValid && isDisplayNameValid;
    };

    if (!profileCheck()) return;

    dispatch({type: START_SAVING});
    repo
      .updateUserInfo(email, displayName, receipt)
      .then((value) => {
        appDispatch({
          type: UPDATE_USER_INFO,
          payload: value,
        });
        history.goBack();
      })
      .catch((error) => {
        appDispatch({
          type: SHOW_APP_MESSAGE,
          payload: {
            type: "failure",
            message: errorHandler(error),
          },
        });
      })
      .finally(() => {
        dispatch({type: HIDE_LOADING});
      });
  };

  return {state, dispatch, updateProfile};
};

const [ProfileSettingProvider, useProfileSettingContext] = constate(useProfileSetting);

export {ProfileSettingProvider, useProfileSettingContext};
